import { IcoCode16, IcoFileText16, IcoImages16, type Icon } from '@onefootprint/icons';
import type { OnboardingDataEntry, OnboardingDataSchemaFile } from '@onefootprint/request-types/dashboard';

// Note: There's a conversion case issue, that is keeping all the keys inside schema as snake_case instead of camelCase
export const getFileMetadata = (artifact: OnboardingDataEntry) => {
  const isFile = artifact.schema?.kind === 'file';
  const fileSchema = isFile ? (artifact.schema as OnboardingDataSchemaFile) : null;
  const schemaData = fileSchema?.data as { mime_type?: string; name?: string; mimeType?: string } | undefined;
  const mimeType = schemaData?.mime_type ?? schemaData?.mimeType ?? '';
  const fileName = schemaData?.name ?? artifact.key;
  const base64Value = typeof artifact.value === 'string' ? artifact.value : null;

  return { isFile, mimeType, fileName, base64Value };
};

export { decodeBase64 } from '@/utils/decode-base64';

export const getFileArtifactIcon = (artifact: OnboardingDataEntry): Icon => {
  const { mimeType } = getFileMetadata(artifact);
  if (!mimeType) {
    return IcoFileText16;
  }
  if (mimeType.startsWith('image/')) {
    return IcoImages16;
  }
  if (mimeType === 'application/json') {
    return IcoCode16;
  }
  if (mimeType.startsWith('text/')) {
    return IcoFileText16;
  }
  return IcoFileText16;
};
